import { render, staticRenderFns } from "./nhom.vue?vue&type=template&id=3fdfab66"
import script from "./nhom.vue?vue&type=script&lang=js"
export * from "./nhom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports